export default function getBodySize() {
	return document.defaultView
		.getComputedStyle(document.querySelector('body'), ':after')
		.getPropertyValue('content')
		.replace(/"/g, '');
}
